import type { GroupCodeType } from '@shared/utils/constants';

import type { Variant } from '@features/Appointment/types/appointment.types';

export interface AppointmentType {
  Code: string;
  Display: string;
  Extension: string[];
  Text: string;
}

export const SupportingInfoType = {
  Encounter: 'Encounter',
  Organization: 'Organization',
  Questionnaire: 'Questionnaire',
} as const;

export interface SupportingInformation {
  Display: string;
  Id: string;
  Reference: string;
  Type: SupportingInfoTypeType;
}
type SupportingInfoTypeType = (typeof SupportingInfoType)[keyof typeof SupportingInfoType];

export const LoadingKeySaving = {
  BackToSummary: 'BackToSummary',
  Next: 'Next',
  SaveAsDraft: 'SaveAsDraft',
} as const;

export interface Appointment {
  AppointmentId: string;
  AppointmentLinkId: string;
  AppointmentLinks: Appointment[];
  AppointmentStatus: string;
  AppointmentType: AppointmentType;
  ApptDate?: string;
  ApptTime?: string;
  ArrivalTime?: string;
  CallSlotSearchDateRangeSeparately: boolean;
  CanAddVisitor: boolean;
  CanCancel: boolean;
  CanMake: boolean;
  CanRegister: boolean;
  CanReschedule: boolean;
  ClinicCode: null | string;
  ClinicInformation?: ClinicInformationType;
  ClusterCode: string;
  Comment: null | string;
  ConfirmHelpInfo?: null | string;
  Department: string;
  Description: string;
  EncounterId?: string;
  End: string;
  GroupCode?: GroupCodeType | null;
  InstitutionName: string;
  IsBundledAppointment: boolean;
  IsCeqmsPoly?: boolean;
  IsHsg: boolean;
  IsMregDisabled?: boolean;
  IsVcSupported: boolean;
  Location: string;
  Logo: string;
  OffsetDays?: string;
  OrderExpectedDate?: string;
  OrganizationUnit?: string;
  ParticipantLocation: string;
  PatientCharterMessage?: null | string;
  PatientInstruction: null | string;
  PractitionerId?: string;
  Provider: string;
  QuestionnaireStatus: null | QuestionnaireStatus[];
  RegistrationAppointmentId?: string;
  RegistrationAvailability?: string;
  RescheduleMessage: null | string;
  ServiceType: string;
  SlotHelpInfo: string;
  SlotId: string;
  SlotSearchDateRangeFrom: null | string;
  SlotSearchDateRangeTo: null | string;
  SourceSystem: string;
  Specialty: string;
  Start: string;
  SupportingInfo: SupportingInformation[];
  Variants?: null | Variant[];
  VisitNumber?: string;
  VisitTypeId: string;
}

export interface ClinicInformationType {
  apptDate?: string;
  apptTime?: string;
  department?: string;
  institutionName?: string;
  location?: string;
  provider?: string;
  service?: string;
  time?: null | string;
}

export interface GetAppointmentListPayload {
  MemberPrn?: string;
  Organization?: string;
  PatientRelationType?: string;
}

export interface GetAppointmentLists {
  MissedAppointments: Appointment[];
  MoreInformation: MoreInfo[];
  OpenAppointments: Appointment[];
  UpcomingAppointments: Appointment[];
}
export type LoadingKeySavingType = (typeof LoadingKeySaving)[keyof typeof LoadingKeySaving];
export interface MoreInfo {
  Issues: Issue[];
  Message: string;
}

export interface QuestionnaireStatus {
  QuestionnaireId: string;
  QuestionnaireStatus: string;
}

interface Issue {
  SourceSystemCode: string;
  SourceSystemMessage: string;
}
